import { memo } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { IProfileAddButton } from '../../../../interfaces/components/profileElement.interface';
import { RoleViewEnum } from '../../../../interfaces/profile.interface';

const ProfileInfoAddButton: React.FC<IProfileAddButton> = ({
  roleView,
  modalName,
  content,
  setModal,
}) => {
  return (
    <>
      {roleView === RoleViewEnum.Owner && (
        <div
          className="flex py-4 cursor-pointer"
          onClick={() =>
            setModal({
              isOpen: true,
              name: modalName,
              value: null,
            })
          }
        >
          <div className="bg-blur_primary rounded-full p-2">
            <AiOutlinePlus className="text-primary text-[16px]" />
          </div>
          <p className="text-primary_black text-[14px] ml-4 leading-[32px]">
            {content}
          </p>
        </div>
      )}
    </>
  );
};

export default memo(ProfileInfoAddButton);
